export const namespaced = true

export const state = () => ({
  categories: [],
  category: null,
  input: null
})

export const getters = {
  categories (state) {
    return state.categories
  },
  category (state) {
    return state.category
  },
  input (state) {
    return state.input
  }
}

export const mutations = {
  SET_CATEGORIES (state, cats) {
    state.categories = cats
  },
  SET_CATEGORY (state, cat) {
    state.category = cat
  },
  SET_INPUT (state, input) {
    state.input = input
  }
}

export const actions = {
  setCategories ({ commit }, cats) {
    commit('SET_CATEGORIES', cats)
  },
  setCategory ({ commit }, cat) {
    commit('SET_CATEGORY', cat)
  },
  setInput ({ commit }, input) {
    commit('SET_INPUT', input)
  }
}
